import { api } from "../config/api";

export const applyPunishment = async (freelancerId, companyId, data) => {
  const response = await api.post(`/Punishments/${freelancerId}/by/${companyId}`, {
    reason: data.reason,
    description: data.description || null,
    jobApplicationId: data.jobApplicationId || null,
  });
  return response.data;
};

export const getFreelancerBanStatus = async () => {
  const userId = localStorage.getItem("userId");
  if (!userId) {
    return { isBanned: false, activePunishments: 0 };
  }

  const response = await api.get(`/Punishments/freelancer/${userId}/status`);
  return response.data;
};

export const getFreelancerPunishments = async () => {
  const userId = localStorage.getItem("userId");
  if (!userId) {
    return [];
  }

  const response = await api.get(`/Punishments/freelancer/${userId}`);
  return response.data;
};

export const getUnlockFee = async () => {
  const response = await api.get("/Punishments/unlock-fee");
  return response.data;
};

export const unlockAccount = async () => {
  const userId = localStorage.getItem("userId");
  if (!userId) {
    throw new Error("Usuário não autenticado");
  }

  const response = await api.post(`/Punishments/freelancer/${userId}/unlock`);
  return response.data;
};